import { render, staticRenderFns } from "./BackBottom.vue?vue&type=template&id=37ca424d"
import script from "./BackBottom.vue?vue&type=script&lang=js"
export * from "./BackBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports